import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { getContentData } from "./redux-toolkit/content/contentSlice";
import { useSelector } from "react-redux";
import { Circles } from "react-loader-spinner";
import ServiceRoutes from "./servicesRouter";
import ServiceCityRoutes from "./serviceCityRouter";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import Faq from "./components/faq/Faq";

const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy/PrivacyPolicy"));
const KundCase = lazy(() => import("./pages/CasePage/CasePage"));
const CaseStudyDetail = lazy(
  () => import("./pages/CaseStudyDetail/CaseStudyDetail.jsx")
);

const Holyrock = lazy(
  () => import("./pages/Kundcase/Hollyrock/holyrockbarber.js")
);

const LeadsDetails = lazy(() => import("./pages/LeadsDetails"));
const PrivatRoute = lazy(() => import("./pages/PrivatRoute"));
const Services = lazy(() => import("./pages/InfoPages/Services/Services"));
const AboutUsPage = lazy(() => import("./pages/OmOss/OmOss"));
const HelhetslosningDigitalMarknadsforing = lazy(
  () =>
    import(
      "./pages/InfoPages/Services/HelhetslosningDigitalMarknadsforing/HelhetslosningDigitalMarknadsforing"
    )
);
const Implementation = lazy(() => import("./pages/InfoPages/Implementering"));
const Partners = lazy(() => import("./components/Partners"));
const Links = lazy(() => import("./internalLinks/Links"));
const SeoServiceComponent = lazy(
  () => import("./components/SeoServiceComponent")
);
const Konsultation = lazy(() => import("./pages/InfoPages/Konsultation"));

const Kontinuerlig = lazy(() => import("./pages/InfoPages/Continuous"));
const Analys = lazy(() => import("./pages/InfoPages/Analys"));

const ForFragan = lazy(() => import("./components/Query"));
const Skapande = lazy(() => import("./pages/Skapande"));
const ContactUs = lazy(() => import("./pages/ContactUs/ContactUs"));
const ServicesIconsComp = lazy(() => import("./components/ServicesIconsComp"));
const Error = lazy(() => import("./pages/Error/Error"));
const Home = lazy(() => import("./pages/Home/Home"));
const Footer = lazy(() => import("./components/Footer/Footer"));
const Besok = lazy(() => import("./components/Besok"));
const ExternaLankar = lazy(
  () => import("./components/externalLinks/ExternaLankar")
);
const Recensioner = lazy(() => import("./components/Recensioner"));
const BookingModal = lazy(
  () => import("./components/BookingModal/BookingModal")
);
const Seoblogg = lazy(() => import("./pages/InfoPages/SeoBlogg"));
const Blogg1 = lazy(() => import("./pages/Blogs/DigitalMarknadsforingsBlog"));
const Blogg2 = lazy(() => import("./pages/Blogs/LokaltTillGlobalt"));
const Blogg3 = lazy(() => import("./pages/Blogs/SeoBlog"));

const App = () => {
  const contentData = useSelector(getContentData);
  return (
    <div className="App">
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100vw",
            }}
          >
            <Circles height="80" width="80" color="#00a7ac" />
          </div>
        }
      >
        <Router>
          <Routes>
            {/* Home Page */}
            <Route
              path="/"
              element={<Home videoText={contentData?.videoText} />}
            />

            <Route
              path="/home"
              element={<Home videoText={contentData?.videoText} />}
            />

            {/* Service Routes */}
            {ServiceRoutes()}
            {/* Service City Routes */}
            {ServiceCityRoutes()}
            {/* Additional Routes */}
            <Route path="/implementering" element={<Implementation />} />
            <Route path="/seo-blogg" element={<Seoblogg />} />
            <Route path="/tjanster" element={<Services />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/kundcase" element={<KundCase />} />
            <Route path="/kundcase/:id" element={<CaseStudyDetail />} />
            <Route path="/kundcase/holyrockbarber" element={<Holyrock />} />
            <Route path="/om-oss" element={<AboutUsPage />} />
            <Route
              path="/tjanst/helhetslosning-digital-marknadsforing"
              element={<HelhetslosningDigitalMarknadsforing />}
            />
            <Route path="/forfragan" element={<ForFragan />} />
            <Route path="/boka" element={<BookingModal />} />
            <Route path="*" element={<Error />} />
            <Route path="/skapande" element={<Skapande />} />

            <Route path="/konsultation" element={<Konsultation />} />

            <Route path="/analys" element={<Analys />} />
            <Route path="/kontinuerlig" element={<Kontinuerlig />} />

            <Route path="/kontakt" element={<ContactUs />} />
            <Route path="/marknadsforingskampanj-blog" element={<Blogg1 />} />
            <Route path="/digitala-strategier-blog" element={<Blogg2 />} />
            <Route path="/seo-grunder-blog" element={<Blogg3 />} />
          </Routes>
          <CookieBanner />
          <Partners />
          <Besok />
          <SeoServiceComponent />
          <ServicesIconsComp />
          <Faq />
          <Recensioner />
          <Footer />
          <Links />
        </Router>
      </Suspense>
    </div>
  );
};

export default App;
